<template>
    <div id="app">
        <main-header></main-header>
        <main>
            <a-row class="content">
                <a-col :md="14" :xs="0">
                    <h2>欢迎回到H5魔塔游戏世界</h2>
                    <img src="/assets/login.png">
                </a-col>
                <a-col :md="8">
                    <a-card>
                        <a-form-model :model="form" :rules="rules" ref="loginForm">
                            <a-form-model-item class="formitem" placeholder="请输入您的用户编号或qq号">
                                <a-input v-model="form.username">
                                    <a-icon slot="addonBefore" type="user" />
                                </a-input>
                            </a-form-model-item>
                            <a-form-model-item class="formitem" placeholder="请输入您的密码">
                                <a-input v-model="form.password" type="password">
                                    <a-icon slot="addonBefore" type="unlock" />
                                </a-input>
                            </a-form-model-item>
                        </a-form-model>
                        <div>
                            <a-button type="primary" @click="login" :loading="isLogining" class="loginbtn">登录</a-button>
                        </div>
                        <div class="carditem">
                            <a class="el-link" href="javascript:void 0" @click="info">忘记密码？</a>
                        </div>
                        <div class="carditem">
                            还没有账号? <a class="el-link" href="/user/register.html">去注册</a>
                        </div>
                    </a-card>
                </a-col>
            </a-row>
        </main>
        <div class="bar"></div>
        <Footer></Footer>
    </div>
</template>

<script>
import MainHeader from '@/components/MainHeader'
import Footer from '@/components/Footer'
import { mapActions } from 'vuex'

export default {
    data: () => ({
        form: {
            username: "",
            password: ""
        },
        isLogining: false,
        rules: {
            username: [
                { required: true, message: '请输入用户名' }
            ],
            password: [
                { required: true, message: '请输入密码' }
            ],
        }
    }),
    methods: {
        ...mapActions([ "doLogin" ]),
        login() {
            this.$refs.loginForm.validate(async(valid) => {
                if (valid) {
                    this.isLogining = true;
                    const res = await this.doLogin(this.form);
                    this.isLogining = false;
                    if (res) {
                        window.location.assign("/");
                    } else {
                        this.$message.error("登录失败");
                    }
                }
            })
        },
        info() {
            const h = this.$createElement;
            this.$info({
                title: '如何找回密码',
                content: h('div', {}, [
                    h('p', '如果你绑定了qq号，可以向小助手私聊发送【重置密码】指令进行重置'),
                    h('p', '一般情况下，请加入群539113091联系群主处理'),
                ]),
                onOk() {},
            });
        }
    },
    components: {
        MainHeader, Footer,
    }
}
</script>

<style lang="less">
html, body {
    height: 100%;
    width: 100%;
    margin: 0;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    cursor: default;
    main {
        background-color: #2C8CF0;
        flex-grow: 1;
        display: flex;
        flex-direction: column;
    }
}
.content {
    margin-top: auto;
    h2 {
        color: white;
    }
    .ant-form-item {
        margin-bottom: 10px;
    }
    .ant-input-group-addon {
        background-color: #2C8CF0;
        color: white;
    }
    .loginbtn span {
        margin: 0px 40px;
    }
    .ant-form.ant-form-horizontal {
        margin-top: 10px;
    }
    .carditem {
        margin-top: 15px;
    }
}
.bar {
    background-color: #EFF2F9;
    height: 100px;
}
</style>
